import apiClient from "./apiClient";

const BASE = "/api/Product";

const toPayload = (data) => ({
  itemName: data.itemName || data.productName || "",
  itemCategory: data.itemCategory,
  unit: data.unit,
  // PurchaseRate / SellingRate / MinimumStockLevel are non-nullable decimal on the API, so
  // they must be a number — null fails model binding exactly as "" does. `|| 0` also fixes
  // a genuine 0 being turned into null, since 0 is falsy.
  purchaseRate: Number(data.purchaseRate) || 0,
  sellingRate: Number(data.sellingRate) || 0,
  minimumStockLevel: Number(data.minimumStockLevel) || 0,
  // DefaultSupplierID is int? — null is correct here when nothing is chosen.
  defaultSupplierID: Number(data.defaultSupplierID) || null,
  status: data.status,
});

// API returns productID (no `id`) — alias it so list/edit code using `.id` works.
const withId = (p) => ({ ...p, id: p.productID });

export const getProducts = async () => {
  const res = await apiClient.get(`${BASE}/all`);
  return { ...res, data: (res.data || []).map(withId) };
};
export const getProduct = (id) => apiClient.get(`${BASE}/${id}`);
export const getProductsByCategory = async (category) => {
  const res = await apiClient.get(`${BASE}/category/${category}`);
  return { ...res, data: (res.data || []).map(withId) };
};
export const createProduct = (data) => apiClient.post(`${BASE}/save`, toPayload(data));
export const updateProduct = (id, data) => apiClient.post(`${BASE}/save`, { ...toPayload(data), productID: id });
export const deleteProduct = (id) => apiClient.delete(`${BASE}/${id}`);
